import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({
  description,
  lang,
  meta,
  title,
  link,
  ratingValue,
  ratingCount,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
            siteLogo
          }
        }
      }
    `
  )

  console.log("site: ", site)

  const metaDescription = description || site.siteMetadata.description

  const createRating = () => {
    if (ratingValue && ratingCount) {
      return {
        "@type": "CreativeWorkSeries",
        name: title,
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: ratingValue,
          ratingCount: ratingCount,
        },
      }
    }
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        url: `${site.siteMetadata.siteUrl}/${link}`,
        name: title,
        description: metaDescription,
        mainEntityOfPage: {
          "@type": "WebSite",
          "@id": site.siteMetadata.siteUrl,
        },
        publisher: {
          "@type": "Person",
          name: site.siteMetadata.author,
          logo: {
            "@type": "ImageObject",
            url: `${site.siteMetadata.siteUrl}${site.siteMetadata.siteLogo}`,
          },
        },
      },
      createRating(),
    ],
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title === "" ? `${site.siteMetadata.title}` : title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: "author",
          content: `${site.siteMetadata.author}`,
        },
        {
          name: "viewport",
          content: "width=device-width, initial-scale=1.0",
        },
      ].concat(meta)}
    >
      <link rel="canonical" href={`${site.siteMetadata.siteUrl}/${link}`} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(structuredData, null, 2),
        }}
      />
    </Helmet>
  )
}

SEO.defaultProps = {
  title: "",
  lang: `pl`,
  meta: [],
  description: ``,
  link: "",
  ratingValue: "",
  ratingCount: "",
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  link: PropTypes.string,
  ratingValue: PropTypes.string,
  ratingCount: PropTypes.string,
}

export default SEO
